export function isAppleNativeFormPlatform() {
  if (typeof navigator === "undefined") return false;
  try {
    const p = navigator.userAgentData?.platform;
    if (p === "macOS" || p === "iOS") return true;
  } catch (_) {}
  const ua = navigator.userAgent || "";
  if (/iPhone|iPad|iPod/.test(ua)) return true;
  if (/Macintosh/.test(ua)) return true;
  return false;
}
export function syncDocumentNativeSelectChromeClass() {
  if (typeof document === "undefined") return;
  const el = document.documentElement;
  if (isAppleNativeFormPlatform()) {
    el.classList.remove("nm-native-select-light-chrome");
  } else {
    el.classList.add("nm-native-select-light-chrome");
  }
}
